import { render } from "./ItemPage.vue?vue&type=template&id=75498901&scoped=true"
import script from "./ItemPage.vue?vue&type=script&lang=js"
export * from "./ItemPage.vue?vue&type=script&lang=js"

import "./ItemPage.vue?vue&type=style&index=0&id=75498901&scoped=true&lang=css"
import "./ItemPage.vue?vue&type=style&index=1&id=75498901&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75498901"]])

export default __exports__